import React, { useState } from "react";
import {  useNavigate } from "react-router-dom";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import { Loading } from "../../../../../../Other/Loading";
import { Link } from "react-router-dom";

const EditSubmit = ({
  popup,
  warning,
  closeHandler,
  success,
  editResponse,
}) => {
  const navigate = useNavigate();
  const [warningShow, setWarning] = useState(warning);
  const reload = () => {
    navigate("/dashboard/courses");
  };

  const handleCancel = () => {
    closeHandler(false);
    setWarning(false);
  };
  return (
    <>
      <OverlayContainer>
        {popup && (
          <div className="alert-dialog-inner editcourse-popup">
            <div className="alert-title">
              <p>Please wait Uploading Edit Course ....</p>
              <Loading />
            </div>
          </div>
        )}

        {editResponse && success && (
          <div className="alert-dialog-inner editcourse-popup">
            <div className="alert-title">
              <div className="alert-dialog-close">
                <div>
                  <i onClick={handleCancel} className="icon check"></i>
                </div>
              </div>
              {editResponse.error ? (
                <>
                  {editResponse ? (
                    <>
                      <img
                        src={`${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-failure-check.svg`}
                        alt="check-failure"
                      />
                      <p>
                        {(editResponse?.data?.length > 0 &&
                          editResponse?.data[0]?.msg) ||
                          editResponse?.message}
                      </p>
                    </>
                  ) : (
                    <Loading />
                  )}
                </>
              ) : (
                <>
                  {editResponse ? (
                    <>
                      <img
                        src={`${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-complete-check.svg`}
                        alt="check-complete"
                      />
                      <p>{editResponse?.message}</p>
                    </>
                  ) : (
                    <Loading />
                  )}
                </>
              )}

              {editResponse && (
                <div className="alert-close-btn">
                  <Link to="/dashboard" className="btn-save">
                    Go to Dashboard
                  </Link>
                </div>
              )}
            </div>
          </div>
        )}

        {warningShow && (
          <div className="alert-dialog-inner editcourse-popup">
            <div className="alert-dialog-close">
              <div>
                <i onClick={handleCancel} className="icon check"></i>
              </div>
            </div>
            <div className="alert-title">
              <h1>Warning!</h1>
            </div>
            <div className="alert-message">
              <p>Are you sure you want to cancel all changes?</p>
            </div>

            <div className="alert-close-btn">
              <a onClick={reload}>YES</a>
              <a className="btn-cancel" onClick={handleCancel}>
                No
              </a>
            </div>
          </div>
        )}
      </OverlayContainer>
    </>
  );
};
export default EditSubmit;
